(ns teamoesterreich.admin-mode.data.questionnaire
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))

(defn date-to-restDate [d]
  (let [t (clojure.string/replace (str (.toISOString d)) #"\.|:|-" "")]
    (str (subs t 0 15) "." (subs t 15))))


(defn get-questionnaire-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/questionnaire?comfort=1")
              (fn [r-list status]
                ;(log/debug "get-questionnaire done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (map (fn [e] [(get e "questionnaireQuestionnaire-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                    )))))

(defn >new-questionnaire [name finished-fn]
  (ajax/auth-post> (backend/get-auth)  (str  backend/BASE_URL "/questionnaire" )
              (ajax/serialize {:questionnaireQuestionnaire-active true
                               :questionnaireQuestionnaire-published false
                               :questionnaireQuestionnaire-name name})
              (fn [data status]
                (when (= status 200)
                  (finished-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse data))))
                    )))))




(defn <get-questionnaire [questionnaire-uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str  backend/BASE_URL "/questionnaire/" questionnaire-uuid)
              (fn [r-list status]
                (when (= status 200)
                  (done-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                    )))))

(defn >questionnaire-edit [questionnaire-uuid questionnaire finished-fn]
  (ajax/auth-put> (backend/get-auth)  (str  backend/BASE_URL "/questionnaire/" questionnaire-uuid)
             (ajax/serialize (merge questionnaire
                                    {:questionnaireQuestionnaire-uuid questionnaire-uuid}))
             finished-fn))




;; Questions


(defn <get-question-list [questionnaire-uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/questionnaire-question/for-questionnaire/" questionnaire-uuid)
              (fn [r-list status]
                ;(log/debug "get-questionnaire done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (map (fn [e] [(get e "questionnaireQuestion-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                    )))))


(defn >questionnaire-add-new-question  [questionnaire-uuid name index finished-fn]
  (ajax/auth-post> (backend/get-auth)  (str backend/BASE_URL "/questionnaire-question" )
              (ajax/serialize {:questionnaireQuestionnaire-uuid questionnaire-uuid
                               :questionnaireQuestion-active true
                               :questionnaireQuestion-index index
                               :questionnaireQuestion-question name})
              finished-fn))


(defn >question-save [uuid data finished-fn]
  (let [data (merge data [:questionnaireQuestion-uuid uuid])]
    (ajax/auth-put> (backend/get-auth)  (str backend/BASE_URL "/questionnaire-question/" uuid)
               (ajax/serialize data)
               finished-fn)))


(defn >question-save-index [uuid index finished-fn]
  (>question-save uuid {:questionnaireQuestion-index index} finished-fn))


;; questionnaire-answerOption

(defn >answerOption-add-new  [question-uuid name index finished-fn]
  (ajax/auth-post> (backend/get-auth)  (str backend/BASE_URL "/questionnaire-answerOption" )
              (ajax/serialize {:questionnaireQuestion-uuid question-uuid
                               :questionnaireAnswerOption-active true
                               :questionnaireAnswerOption-index index
                               :questionnaireAnswerOption-type "checkbox"
                               :questionnaireAnswerOption-text name})
              finished-fn))

(defn >answerOption-save [uuid data finished-fn]
  (let [data (merge data [:questionnaireAnswerOption-uuid uuid])]
    (ajax/auth-put> (backend/get-auth)  (str backend/BASE_URL "/questionnaire-answerOption/" uuid)
               (ajax/serialize data)
               finished-fn)))


(defn >answerOption-save-index [uuid index finished-fn]
  (>answerOption-save uuid {:questionnaireAnswerOption-index index} finished-fn))




(defn load-question-list [& [finished-fn]]
  (let [uuid (get-in @vstate/app-state [:edit-questionnaire :selected-questionnaire :questionnaireQuestionnaire-uuid])]
    (<get-question-list uuid
                        (fn [response]
                          (swap! vstate/app-state assoc-in [:edit-questionnaire :questions] response)
                          (when finished-fn (finished-fn))))))























